// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"info-text_infoContainer__IWz0j","infoContainer--marginTop":"info-text_infoContainer--marginTop__DQ9iP","iconWrapper":"info-text_iconWrapper__Wtb36"};